(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/kambi-widget-utils/assets/javascripts/init-kambi-widgets.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/kambi-widget-utils/assets/javascripts/init-kambi-widgets.js');
"use strict";


const {
  ImpleoWidgetDefinition,
  SeoTextWidgetDefinition
} = svs.oddset_kambi.components.kambiWidgetUtils.definitions;
const initKambiWidgets = () => {
  const widgetDefinitions = [];
  if (svs.core.detect.feature('ft-kambi-client-impleo-widget')) {
    widgetDefinitions.push(new ImpleoWidgetDefinition());
  }
  widgetDefinitions.push(new SeoTextWidgetDefinition());

  if (!widgetDefinitions.length) {
    return;
  }
  const widgets = [];
  const targets = {};
  for (const widgetDefinition of widgetDefinitions) {
    widgets.push(widgetDefinition.getDefinition());
    const widgetTargets = widgetDefinition.getTargets();
    for (const targetKey in widgetTargets) {
      if (Array.isArray(targets[targetKey])) {
        targets[targetKey] = [...targets[targetKey], ...widgetTargets[targetKey]];
      } else {
        targets[targetKey] = widgetTargets[targetKey];
      }
    }
  }
  window.widgetSettings = {
    widgets,
    targets
  };
};
setGlobal('svs.oddset_kambi.components.kambiWidgetUtils.initKambiWidgets', initKambiWidgets);

 })(window);